import Vue from 'vue';
import DatetimePicker from 'vuetify-datetime-picker';
import App from './App.vue';
import vuetify from './plugins/vuetify';

import router from './routes';
import store from './store';

import 'vuetify/dist/vuetify.min.css';
import { createAxiosInstance } from './utils/axios';

Vue.config.productionTip = false;

export const axiosInstance = createAxiosInstance();

export const busEvent = new Vue();

Vue.use(DatetimePicker);

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
